/**
 *
 */

import proj4 from 'proj4';

// ------------------------------------------------------------------
// START Configure proj4 for coordinate conversions using aliases
// https://github.com/proj4js/proj4js
// http://proj4js.org
// ------------------------------------------------------------------

// The correct definitions for proj4 are available at the following websites
// https://epsg.io OR http://spatialreference.org
// (you can search for "GPS" or "NZTM" on epsg.io)
const WGS84 = "+title=WGS 84 (long/lat) +proj=longlat +ellps=WGS84 +datum=WGS84 +units=degrees";
const EPSG_2193 = "+proj=tmerc +lat_0=0 +lon_0=173 +k=0.9996 +x_0=1600000 +y_0=10000000 +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs";
const GPS = WGS84;
const NZTM = EPSG_2193;

proj4.defs('GPS', GPS);
proj4.defs('NZTM', NZTM);

export default proj4;


// WEBPACK FOOTER //
// ./src/wrappers/proj4.js